<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-sprawy' aria-label='E-usługi'>Moje sprawy</a>
    </li>
    @if (loading()) {
      <li>
        Ładowanie danych...
      </li>
    } @else {
      <li>
        <a routerLink="../../"
           [attr.aria-label]="'Szczegóły sprawy nr.: ' + shipment()?.caseEntity?.caseNumber">{{ shipment()?.caseEntity?.caseNumber || 'Brak numeru' }}</a>
      </li>
      <li>
        {{ shipment()?.concerns || 'Szczegóły pisma' }}
      </li>
    }
  </app-breadcrumbs>
  @if (!loading()) {
    <section>
      <h2>
        {{ shipment()?.concerns || 'Szczegóły pisma' }}
      </h2>
      <div class="gov-card">
        <div class="gov-card__body">
          <div class="row">
            <div class="col-12">
              <app-label label="Rodzaj pisma: ">
                {{ shipment()?.incoming ? 'Przychodzące' : 'Wychodzące' }}
              </app-label>
            </div>
            @if (shipment()?.incoming) {
              <div class="col-12">
                <app-label label="Nadawca:">
                  {{ shipment()?.senderName || ((shipment()?.senderFirstname || '') + ' ' + (shipment()?.senderLastname || 'Brak danych') || '') }}
                </app-label>
              </div>
            }
            <div class="col-12">
              <app-label label="Dotyczy: ">
                {{ shipment()?.concerns || '-' }}
              </app-label>
            </div>
            <div class="col-12">
              <app-label [label]="shipment()?.incoming ? 'Data otrzymania:' : 'Data wysłania:'">
                {{ (shipment()?.createdAt | date) || 'Brak danych' }}
              </app-label>
            </div>
          </div>
        </div>
      </div>
      <br>
      <dl class="mb-5">
        <dt class="mb-2">
          <strong>Załączniki:</strong>
        </dt>
        <dd>
          <ul class="item-list">
            @for (item of shipment()?.attachments || []; track $index) {
              <li>
                <a href="#"
                   (click)="onDownloadAttachment($event, item)">{{ item.attachment?.customName || item.attachment?.originalName }}</a>
              </li>
            }
          </ul>
        </dd>
      </dl>
    </section>
  } @else {
    <app-spinner>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  }
</app-content>
